import { Controller } from "stimulus"
import Chart from 'chart.js/auto';

export default class extends Controller {

  static targets = [ "collectionControls", "samplings", "measure", "performanceChart", "id", "recyclablesPercentage", "organicsPercentage", "wastsPercentage", "route", "printUrl" ]

  connect() {
    if (document.body.getAttribute("data-action").includes("new")) {
      var cleave = new Cleave(".input-date", {
        date: true,
        datePattern: ["d", "m", "Y"]
      })
    }
    if (document.body.getAttribute("data-action").includes("view") || document.body.getAttribute("data-action").includes("show") || document.body.getAttribute("data-action").includes("print_report") || document.body.getAttribute("data-action").includes("print")) {
      this.buildChart(this.recyclablesPercentageTarget.value, this.organicsPercentageTarget.value, this.wastsPercentageTarget.value)
    }
  }

  changeCustomer(event) {
    var collectionControls = this.collectionControlsTarget
    var samplings = this.samplingsTarget
    collectionControls.options.length = 1
    samplings.options.length = 1
    if (event.target.value != "") {
      fetch("/relatorios/" + event.target.value).then(
        function(response) {
          return response.json().then(function(json) {
            for (var i = 0; i < json.collection_controls.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json.collection_controls[i]["period"]))
              option.value = json.collection_controls[i]["_id"]["$oid"]
              collectionControls.appendChild(option)
            }
          })
        }
      )
    }
  }

  changeCollectionControl(event) {
    var samplings = this.samplingsTarget
    samplings.options.length = 1
    if (event.target.value != "") {
      fetch("/relatorios/amostragens/" + event.target.value).then(
        function(response) {
          return response.json().then(function(json) {
            for (var i = 0; i < json.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json[i]["text"]))
              option.value = json[i]["_id"]["$oid"]
              samplings.appendChild(option)
            }
          })
        }
      )
    }
  }

  updatePerformanceChart() {
    fetch(this.routeTarget.value, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        report: {
          id: this.idTarget.value,
          measure: this.measureTarget.value
        }
      })
    }).then(async (response) => {
      if (response.status == 200) {
        const data = await response.text()
        this.performanceChartTarget.innerHTML = data
        this.printUrlTarget.href = this.printUrlTarget.href.split("?")[0] + "?measure=" + this.measureTarget.value
        this.buildChart(this.recyclablesPercentageTarget.value, this.organicsPercentageTarget.value, this.wastsPercentageTarget.value)
      } else {
        const data = await response.json()
        console.log("Ocorreu um erro ao filtrar a dashboard...")
      }
    })
  }

  buildChart(recyclable, organic, wast) {
    const data = {
      labels: [
        'Recicláveis',
        'Orgânicos',
        'Rejeitos'
      ],
      datasets: [{
        data: [recyclable, organic, wast],
        backgroundColor: [
          'rgb(127, 199, 169)',
          'rgb(144, 130, 122)',
          'rgb(255, 159, 28)'
        ],
        hoverOffset: 4
      }]
    };

    var ctx = document.getElementById('chart')
    new Chart(ctx, {
        "type": "pie",
        data: data,
        options: {
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            }
          }
        }
    })
  }
}
